import { ServiceSlugs } from '@ply-io/ply-front-shared-utilities';

import { FieldType } from '@/components/BlockEditorWidget/widgetFieldTypes.const';

export const INTERFACE = 'interface';
export const MAX_NUM_OF_APPS_TO_DISPLAY_IN_PREVIEW = 6;

export const POPULAR_APPS_SLUGS = [
	ServiceSlugs.GmailWorkspace,
	ServiceSlugs.GoogleSheets,
	ServiceSlugs.Slack,
	ServiceSlugs.Monday,
	ServiceSlugs.Airtable,
];

export const UN_CHANGEABLE_TO_AND_FROM_SERVICE_SLUGS = [
	ServiceSlugs.Loop,
	ServiceSlugs.EndRun,
	//	ServiceSlugs.Widgets,
	ServiceSlugs.Branches,
];

export const TABLE_MAPPER_MINI_APP = FieldType.TableMapper;
export const AI_MINI_APP = FieldType.AIInput;
export const LOOM_MINI_APP = FieldType.Loom;
export const IMAGE_EDITOR_APP = FieldType.ImageEditor;
export const HUBSPOT_SCHEDULER_APP = FieldType.HubspotScheduler;
export const CALENDLY_MINI_APP = FieldType.Calendly;
export const GOOGLE_DOCS_MINI_APP = FieldType.GoogleDocs;
export const STRIPE_MINI_APP = FieldType.Stripe;
